import React, { FC, useContext } from "react";
import { defineMessages, useIntl } from "react-intl";

import {
  BillingHistoryPaymentCard,
  BillingHistoryTemplate,
} from "@app/postBill/components/billingCenterHistory";
import { PostBillHistoryContext } from "@app/provider";
import { PaymentHistoryItem } from "@app/postBill/models";
import { useNavigate } from "react-router-dom";
import { usePostBillHeapEvent } from "@app/postBill/hooks";
import { HEAP_EVENTS } from "@app/provider/types";
import { routes } from "@app/routing";

const messages = defineMessages({
  billingHistoryPaymentsTitle: {
    id: "billingHistoryPaymentsTitle",
    defaultMessage: "Payment history",
  },
});

const BillingHistoryPayments: FC = () => {
  const intl = useIntl();
  const {
    loadPaymentsHistory,
    testCards,
    togglePaymentsSort,
    loadPaymentsPage,
  } = useContext(PostBillHistoryContext);
  const navigate = useNavigate();
  const { trackPostBillHeapEvent } = usePostBillHeapEvent();

  const onViewReceipt = async (paymentIntentId: string) => {
    trackPostBillHeapEvent({ eventKey: HEAP_EVENTS.upp_click_view_receipt });
    navigate(routes.billingReceiptPdf, { state: { paymentIntentId } });
  };

  const renderTestCards = () => {
    return (
      <div>
        {testCards &&
          (testCards as PaymentHistoryItem[]).map(
            (item: PaymentHistoryItem) => (
              <BillingHistoryPaymentCard
                key={item?.bosPaymentObjectId}
                testName={item?.testName}
                amount={item?.amount}
                currency={item?.currency}
                caseNumber={item?.caseNumber}
                dateOfService={item?.dateOfService}
                paymentMethod={item?.paymentMethod}
                receiptId={item?.receiptId}
                paidDate={item?.paidDate}
                onViewReceipt={() => onViewReceipt(item?.upsPaymentId ?? "")}
              />
            )
          )}
      </div>
    );
  };

  return (
    <BillingHistoryTemplate
      title={intl.formatMessage(messages.billingHistoryPaymentsTitle)}
      loadHistory={loadPaymentsHistory}
      loadPage={loadPaymentsPage}
      toggleSort={togglePaymentsSort}
      medium
    >
      {testCards && renderTestCards()}
    </BillingHistoryTemplate>
  );
};

export default BillingHistoryPayments;
